import {
    ComponentFactoryResolver,
    ComponentRef,
    Directive,
    OnChanges,
    SimpleChanges,
    ViewContainerRef
} from '@angular/core';
import {AbstractDisplayComponent} from './abstract-display.component';
import {DateDisplayComponent} from './date-display/date-display.component';
import {TextDisplayComponent} from './text-display/text-display.component';
import {CountryDisplayComponent} from './country-display/country-display.component';
import {OperatorDisplayComponent} from './operator-display/operator-display.component';
import {AirportDisplayComponent} from './airport-display/airport-display.component';
import {CityDisplayComponent} from './city-display/city-display.component';
import {AffilieDisplayComponent} from './affilie-display/affilie-display.component';
import {BooleanDisplayComponent} from './boolean-display/boolean-display.component';


const componentMapper = {
    DATE: DateDisplayComponent,
    DATE_TIME: DateDisplayComponent,
    TEXT: TextDisplayComponent,
    NUMBER: TextDisplayComponent,
    IATA_CITY: CityDisplayComponent,
    IATA_AIRPORT: AirportDisplayComponent,
    IATA_COUNTRY: CountryDisplayComponent,
    CARRIER: OperatorDisplayComponent,
    //
    COUNTRY: CountryDisplayComponent,
    CIVILITY: TextDisplayComponent,
    TIME: DateDisplayComponent,
    AFFILIATION: TextDisplayComponent,
    LANG: TextDisplayComponent,
    EMAIL: TextDisplayComponent,
    PRICE: TextDisplayComponent,
    PHONE: TextDisplayComponent,
    BOOKING_REFERENCE: TextDisplayComponent,
    BOOLEAN: BooleanDisplayComponent,
    DAY_NUMBER: TextDisplayComponent,
    MONTH_NUMBER: TextDisplayComponent,
    PRODUCT_TYPE: TextDisplayComponent,
    CONTACT_TYPE: TextDisplayComponent
    // TIME, AFFILIATION, LANG, CIVILITY
};


@Directive({
    // tslint:disable-next-line:directive-selector
    selector: '[dmpDynamicDisplayDirective]',
    standalone: false
})
export class DynamicDisplayDirective extends AbstractDisplayComponent implements OnChanges{

  componentRef: ComponentRef<any>;

  constructor(
    private resolver: ComponentFactoryResolver,
    private container: ViewContainerRef,
    ) {
      super();
    }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.field){
      this.update();
    }
    if (changes.value && this.componentRef){
      this.componentRef.instance.value = this.value;
    }
  }

  update(){
    if (this.componentRef){
      this.componentRef.destroy();
      this.componentRef = null;
    }
    if (this.field){
      if (!this.field.categoryField){
        this.field.categoryField = 'TEXT';
      }
      let component = componentMapper[this.field.categoryField];
      if (component === undefined && this.field.categoryField === 'TECHNICAL') {
            switch (this.field.type) {
                case 'DateTime':
                    component = componentMapper.DATE_TIME;
                    break;
                default:
                    component = componentMapper.TEXT;
            }
        }
        else if (component === undefined) {
          console.log(this.field.categoryField + ' not found replace by text');
          component = componentMapper.TEXT;
        }
      const factory = this.resolver.resolveComponentFactory(
          component
        );
      this.componentRef = this.container.createComponent(factory);
      this.componentRef.instance.field = this.field;
      this.componentRef.instance.value = this.value;
      this.componentRef.instance.isWrite = this.isWrite;
      this.componentRef.instance.valueChange = this.valueChange;
      this.componentRef.instance.containerParent = this.containerParent;
        //
      if (this.componentRef.instance.ngOnInit){
          this.componentRef.instance.ngOnInit();
        }
    }
  }

}
